/**
 * Содержимое главной страницы
 */
import { IMainPageContent } from '../../types/helper';

// tslint:disable:max-line-length
export const MAIN_PAGE_CONTENT: IMainPageContent = {
  title: 'Помощник по продаже жилья на вторичном рынке',
  body: 'Мы собрали всю самую важную информацию, которая поможет продать недвижимость самостоятельно',
};
// tslint:enable:max-line-length
